// Source única de verdad: ruta admin → módulo de permisos.
// Si una ruta NO está mapeada aquí, queda bloqueada por defecto salvo super_admin.
//
// Las claves son rutas relativas a "/admin" (sin slash inicial) o "" para el
// dashboard. Coinciden con el `path` declarado en App.js dentro de
// <Route path="/admin"> ...
//
// La columna "module" debe coincidir con un slug de SYSTEM_MODULES en
// backend/routes/roles.py (clave usada en role.permissions).

export const ADMIN_MODULES = {
  dashboard: { label: "Dashboard" },
  citas: { label: "Citas" },
  clientes: { label: "Ficha de cliente" },
  vehiculos: { label: "Vehículos" },
  centros: { label: "Centros" },
  empleados: { label: "Empleados" },
  vacaciones: { label: "Vacaciones" },
  usuarios: { label: "Usuarios" },
  contenido_web: { label: "Contenido Web" },
  plantillas_email: { label: "Plantillas Email" },
  configuracion: { label: "Configuración" },
  analytics: { label: "Analítica" },
  export: { label: "Exportaciones" },
  rrhh: { label: "RRHH" },
  audit: { label: "Auditoría" },
  atenciones_comerciales: { label: "Atenciones Comerciales" },
  whatsapp: { label: "WhatsApp" },
  promotions: { label: "Promociones" },
  copias_seguridad: { label: "Copias de Seguridad" },
  sincronizar_contenido: { label: "Sincronizar Contenido" },
  salud_datos: { label: "Salud de Datos" },
  catalogos_rrhh: { label: "Catálogos RRHH" },
  organigrama: { label: "Organigrama" },
  consultas: { label: "Consultas de Contacto" },
  candidaturas: { label: "Candidaturas" },
  formularios: { label: "Formularios" },
  branding: { label: "Branding" },
  gtm: { label: "Google Tag Manager" },
  email_config: { label: "Centro de Emails" },
  diagnostico_permisos: { label: "Diagnóstico Permisos" },
};

// Mapeo ruta admin → slug de módulo. Usa coincidencia EXACTA por defecto;
// si la ruta empieza por uno de los prefijos en MODULE_BY_PREFIX, hereda
// ese módulo.
// Iter 200 (P0) — Este mapeo es FALLBACK estático. La fuente única real es
// `/api/system/route-mapping` (db.system_modules). Mantener sincronizado.
export const MODULE_BY_ROUTE = {
  "": "dashboard",
  "citas": "citas",
  "citas/servicios": "servicios_cita",
  "clientes": "clientes",
  "vehiculos-alquiler": "vehiculos_alquiler",
  "vehiculos": "vehiculos",
  "vendedores": "centros",
  "centros": "centros",
  "empleados": "empleados",
  "vacaciones": "vacaciones",
  "rrhh": "rrhh",
  "rrhh/configuracion": "rrhh_config",
  "exportacion": "export",
  "organigrama": "organigrama",
  "usuarios": "usuarios_sistema",
  "usuarios/migracion": "usuarios_sistema",
  "catalogos-rrhh": "catalogos_rrhh",
  "contenido-web": "contenido_web",
  "promociones": "promotions",
  "plantillas-email": "email_config",
  "configuracion": "configuracion_general",
  "salud-datos": "salud_datos",
  "whatsapp": "whatsapp",
  "ctas-enlaces": "contenido_web",
  "emails-sistema": "email_config",
  "email-config": "email_config",
  "consultas": "consultas",
  "candidaturas": "candidaturas",
  "gtm": "gtm",
  "formularios": "email_config",
  "comunicaciones": "email_config",
  "comunicaciones/plantillas-email": "email_config",
  "notificaciones": "dashboard",
  "seguridad/eventos": "auditoria_permisos",
  "informes-automaticos": "informes_automaticos",
  "permisos-y-roles": "accesos_permisos",
  "usuarios-permisos": "accesos_permisos",
  "accesos-permisos": "accesos_permisos",
  "planificacion-ausencias": "planificador_ausencias",
  "leads-historicos": "leads_historicos",
  "sincronizar-contenido": "sincronizar_contenido",
  "copias-seguridad": "copias_seguridad",
  "copias-seguridad-legacy": "copias_seguridad",
  "diagnostico-permisos": "diagnostico_permisos",
  "auditoria-permisos": "auditoria_permisos",
};

// Prefijos que comparten módulo (ej. /admin/catalogos-rrhh/departamentos).
// IMPORTANTE: ordenar de más específico a más general (atenciones/bonos antes
// que atenciones) para que el match más detallado gane.
export const MODULE_BY_PREFIX = [
  { prefix: "atenciones/bonos", module: "bonos_emitidos" },
  { prefix: "atenciones/emitir", module: "emitir_bono" },
  { prefix: "atenciones/canjes", module: "canjes" },
  { prefix: "atenciones/informes", module: "informes_bonos" },
  { prefix: "atenciones/plantillas", module: "plantillas_bonos" },
  { prefix: "catalogos-rrhh", module: "catalogos_rrhh" },
  { prefix: "atenciones", module: "atenciones_comerciales" },
];

/**
 * Resuelve el módulo asociado a una sub-ruta de /admin (sin barra inicial).
 * Devuelve null si no hay mapeo → la guardia debe bloquear salvo super_admin.
 */
export function moduleForAdminPath(pathSegment) {
  const seg = (pathSegment || "").replace(/^\/+|\/+$/g, "");
  if (seg in MODULE_BY_ROUTE) return MODULE_BY_ROUTE[seg];
  for (const { prefix, module } of MODULE_BY_PREFIX) {
    if (seg === prefix || seg.startsWith(prefix + "/")) return module;
  }
  // Try one level up (e.g. "usuarios/123/edit" → "usuarios")
  const head = seg.split("/")[0];
  if (head && head in MODULE_BY_ROUTE) return MODULE_BY_ROUTE[head];
  return null;
}
